import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/** Format Date as MySQL DATETIME (no timezone, no microseconds) to avoid "Incorrect datetime value" from backend */
export function toMySQLDatetime(date: Date): string {
  return date.toISOString().slice(0, 19).replace("T", " ")
}
